import i18n from 'i18next';
import { switchMapKeyValuePairs } from 'utils/common';

export const ADMIN = 'admin';
export const SUPER_EDITOR = 'super_editor';
export const EDITOR = 'editor';
export const CONTRIBUTOR = 'contributor';
export const ON_SITE_STAFF = 'on_site_staff';

// https://api.feversocial.com/services/admin/roles
// Ex: { uuid: "5e7e1e71-ff18-4931-809d-6b2346326d05", name: "主辦單位管理員" }
// value 對應到後端 API 的 role name
export const roleTypeMap = new Map([
    [ADMIN, '主辦單位管理員'],
    [SUPER_EDITOR, '總編輯'],
    [EDITOR, '編輯'],
    [CONTRIBUTOR, '小編'],
    [ON_SITE_STAFF, 'On-site Staff']
]);

export const getRoleTypeByRoleName = roleName => switchMapKeyValuePairs(roleTypeMap).get(roleName);

export const getRoleByRoleName = roleName => {
    const roleType = getRoleTypeByRoleName(roleName);
    return i18n.t(`label.role_type.${roleType}`);
};

export default roleTypeMap;

export const adminAndEditorRole = new Set([
    roleTypeMap.get(ADMIN),
    roleTypeMap.get(SUPER_EDITOR),
    roleTypeMap.get(EDITOR),
    roleTypeMap.get(CONTRIBUTOR)
]);

export const onsiteStaffRole = new Set([roleTypeMap.get(ON_SITE_STAFF)]);

// 不可使用點數中心人工調整的權限
const canNotManualAdjustmentRole = new Set([
    roleTypeMap.get(CONTRIBUTOR),
    roleTypeMap.get(ON_SITE_STAFF)
]);
export const hasCanNotManualAdjustmentRole = roleName => canNotManualAdjustmentRole.has(roleName);

export const isContributorRole = roleName => roleName === roleTypeMap.get(CONTRIBUTOR);
export const isAdminRole = roleName => roleName === roleTypeMap.get(ADMIN);
export const isSuperEditorRole = roleName => roleName === roleTypeMap.get(SUPER_EDITOR);
export const isEditorRole = roleName => roleName === roleTypeMap.get(EDITOR);
export const isOnSiteStaffRole = roleName => roleName === roleTypeMap.get(ON_SITE_STAFF);
